module.exports = __webpack_public_path__ + "static/media/LinkedinIcon.d142adfc.png";